module.exports = __webpack_public_path__ + "img/pinfl__uz__passport.8321b263.png";